import React, { useState, useEffect } from "react";
import "../styles/skills.css";
import { FaJs, FaJava, FaReact, FaNodeJs, FaGitAlt } from "react-icons/fa";
import {
  SiTypescript,
  SiRedux,
  SiTailwindcss,
  SiMongodb,
  SiMysql,
  SiPostman,
  SiCplusplus,
} from "react-icons/si";
import { DiHtml5, DiCss3 } from "react-icons/di";
import { pageIds } from "../utils/contants";

export const skillsSectionData = [
  {
    title: "Programming Languages",
    skills: [
      { name: "JavaScript", icon: FaJs },
      { name: "TypeScript", icon: SiTypescript },
      { name: "Java", icon: FaJava },
      { name: "C", icon: SiCplusplus },
      { name: "C++", icon: SiCplusplus },
      { name: "Node.js", icon: FaNodeJs },
    ],
  },

  {
    title: "Web Technologies",
    skills: [
      { name: "HTML5", icon: DiHtml5 },
      { name: "CSS3", icon: DiCss3 },
      { name: "React.js", icon: FaReact },
      { name: "Redux Toolkit", icon: SiRedux },
      { name: "Tailwind CSS", icon: SiTailwindcss },
      { name: "Material UI" },
      { name: "Bootstrap" },
    ],
  },
  {
    title: "Backend & APIs",
    skills: [
      { name: "Node.js", icon: FaNodeJs },
      { name: "Express.js" },
      { name: "RESTful APIs" },
      { name: "API Integration" },
      { name: "JWT Authentication" },
    ],
  },
  {
    title: "Database Management",
    skills: [
      { name: "MongoDB", icon: SiMongodb },
      { name: "MySQL", icon: SiMysql },
    ],
  },
  {
    title: "Developer Tools",
    skills: [
      { name: "Git", icon: FaGitAlt },
      { name: "GitHub", icon: FaGitAlt },
      { name: "Postman", icon: SiPostman },
      { name: "VS Code" },
      { name: "Vercel" },
      { name: "Netlify" },
      { name: "NPM" },
    ],
  },
  {
    title: "Core Skills",
    skills: [
      { name: "Data Structures" },
      { name: "Algorithms" },
      { name: "Problem Solving" },
      { name: "Responsive Design" },
      { name: "State Management" },
      { name: "Agile" },
    ],
  },
];

export const Skills = () => {
  const [, setAnimatedPercents] = useState(
    skillsSectionData.map(() => 0)
  );

  useEffect(() => {
    const intervals = [];

    skillsSectionData.forEach((skill, index) => {
      let current = 0;
      const target = skill.percent;

      intervals[index] = setInterval(() => {
        current += 1;
        if (current > target) {
          clearInterval(intervals[index]);
          current = target;
        }
        setAnimatedPercents((prev) => {
          const newPercents = [...prev];
          newPercents[index] = current;
          return newPercents;
        });
      }, 20);
    });

    return () => {
      intervals.forEach((id) => clearInterval(id));
    };
  }, []);

  return (
    <div className="main" id={pageIds.skills}>
      <h1>Skills</h1>

      <div className="skills-grid">
        {skillsSectionData.map((section) => (
          <div className="skill-card" key={section.title}>
            <h3>{section.title}</h3>

            <ul>
              {section.skills.map((skill) => {
                const Icon = skill.icon;
                return (
                  <li key={skill.name}>
                    {Icon && <Icon className="skill-icon" />}
                    <span>{skill.name}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};
